var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHiddenFill = function SvgHiddenFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.7 4-.707.707 7.707 7.707.707-.707-.847-.847a8.274 8.274 0 0 0 1.334-1.906.985.985 0 0 0-.001-.892c-.544-1.07-2.11-3.555-4.893-3.555-.848 0-1.583.231-2.21.582L4.7 4Zm2.625 2.625 2.558 2.558a2.003 2.003 0 0 0-2.558-2.558Z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.508c.123 0 .244-.011.36-.033l1.588 1.587A4.44 4.44 0 0 1 8 12.508c-2.782 0-4.349-2.486-4.893-3.554a.985.985 0 0 1 0-.892l.043-.083a8.369 8.369 0 0 1 1.1-1.615l1.782 1.783A2.003 2.003 0 0 0 8 10.507Z",
    fill: "#000"
  })));
};
export default SvgHiddenFill;